module.exports = __webpack_public_path__ + "static/img/product_society_onestep.6b1ad82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_onestep.png
// module id = r+4D
// module chunks = 0